import { AppConfig } from "./interfaces/app-config";

export const globalConfig: AppConfig = {
  pages: {
    login: {
      title: 'Iniciar sesión',
      subtitle: 'Introduzca su correo electrónico y contraseña para iniciar sesión',
      form: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        rememberMe: {
          label: 'Recordarme'
        },
        agency_id: {
          label: 'Agencias',
          placeholder: 'Seleccionar...'
        },
      },
      socialAuth: 'O inicia sesión con',
      forgotPassword: '¿Ha olvidado su contraseña?',
      submit: 'Iniciar sesión',
      nextAuth: {
        question: '¿No tienes cuenta?',
        action: 'Registrate aquí'
      }
    },
    register: {
      title: 'Registrate',
      subtitle: 'Introduzca sus datos personales para crear una cuenta',
      form: {
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        terms: {
          label: 'Acepto los ',
          action: 'términos y condiciones'
        }
      },
      socialAuth: 'O registrate con',
      submit: 'Registrarse',
      nextAuth: {
        question: '¿Ya tienes una cuenta?',
        action: 'Inicia sesión'
      }
    },
    forgetPassword: {
      title: 'Recuperar contraseña',
      subtitle: 'Introduzca correo electronico de registro.',
      form: {
        code: {
          label: 'Código',
          placeholder: 'Escribir código...',
          action: 'Ingresa el código enviado a su correo de recuperación'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico',
          action: "Ingresa el correo con el que te registraste para recuperar tu contraseña"
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña',
          action: "Ingrese una nueva contraseña, como mínimo debe tener 8 caracteres"
        },
        passwordConfir: {
          label: 'Confirmar contraseña',
          placeholder: 'Confirmar contraseña...'
        },
        passwordCurrent: {
          label: 'Contraseña actual',
          placeholder: 'Escribir contraseña...'
        }
      },
      socialAuth: 'O registrate con',
      submit: 'Registrarse',
      nextAuth: {
        question: '',
        action: 'Ir a Inicia sesión'
      }
    },
    account: {
      title: 'Mi Cuenta'
    },

    shedules: {
      titlePlural: 'Notificaciones programadas',
      titleSingular: 'Notificación programada',
      form: {
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        image: {
          label: 'Imagen',
          placeholder: 'Selecciona una imagen'
        },
        rol: {
          label: 'Asignar rol',
          placeholder: 'Selecciona....'
        },

      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        },
    },


    users: {
      titlePlural: 'Usuarios',
      titleSingular: 'Usuario',
      form: {
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        image: {
          label: 'Imagen',
          placeholder: 'Selecciona una imagen'
        },
        rol: {
          label: 'Asignar rol',
          placeholder: 'Selecciona....'
        },

      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        },
    },


    customer: {
      titlePlural: 'Clientes',
      titleSingular: 'Cliente',
      form: {
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: null,
        cellphone: {
          label: 'Celular',
          placeholder: 'Ingresa tu número de celular'
        },
        code: {
          label: 'Contraseña',
          placeholder: 'Ingresa contraseña'
        },
      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email:null,
        cellphone: {
          label: 'Celular',
          placeholder: 'Ingresa tu número de celular'
        },
        initial_date: {
          label: 'Fecha inicio',
          placeholder: 'Ingresa fecha inicio'
        },
        end_date: {
          label: 'Fecha fin',
          placeholder: 'Ingresa fecha fin'
        },
      }
    },
    profile: {
      titlePlural: 'Perfiles',
      titleSingular: 'Perfil',
      form:{
        name: {
          label: 'Nombre',
          placeholder: 'Escribir nombre'
        },
        last_name: {
          label: 'Apellido',
          placeholder: 'Escribir apellido...'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico...'
        },
        cellphone: {
          label: 'Celular',
          placeholder: 'Escribir celular...'
        },
        birth_date: {
          label: 'Fecha de nacimiento',
          placeholder: 'Escribir Fecha de nacimiento...'
        },
        city: {
          label: 'Ciudad',
          placeholder: 'Escribir ciudad...'
        },
        country: {
          label: 'País',
          placeholder: 'Escribir paós...'
        },
        ci:{
          label: 'Carnet',
          placeholder: 'Ingrese...'
        },
      },
      form_filter: {
        name:{
          label: 'Nombre',
          placeholder: 'Escribir nombre'
        },
        lastName:{
          label: 'Apellido',
          placeholder: 'Escribir apellido'
        },
        email:{
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico'
        },
        numberCi:{
          label: 'Numero de carnet',
          placeholder: 'Escribir numero carnet'
        },
        initial_date:{
          label: 'Fecha inicio',
          placeholder: 'Escribir...'
        },
        end_date:{
          label: 'Fecha fin',
          placeholder: 'Escribir...'
        },
        city:{
          label: 'Ciudad',
          placeholder: 'Escribir...'
        },
        event:{
          label: 'Eventos',
          placeholder: 'Seleccionar...'
        },

      }
    },
    historyTickets: {
      titlePlural: 'Reportes de entradas',
      titleSingular: 'Reporte de entrada',
      form:{},
      form_filter: {
        search: {
          label: 'Buscar código',
          placeholder: 'Escribir código...'
        },
        name:{
          label: 'Nombre',
          placeholder: 'Escribir nombre...'
        },
        lastName:{
          label: 'Apellido',
          placeholder: 'Escribir apellido...'
        },
        email:{
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico...'
        },
        numberCi:{
          label: 'Numero de carnet',
          placeholder: 'Escribir numero de carnet...'
        },
        initial_date:{
          label: 'Fecha inicio',
          placeholder: 'Escribir fecha inicio...'
        },
        end_date:{
          label: 'Fecha fin',
          placeholder: 'Escribir fecha fin...'
        },
        event:{
          label: 'Eventos',
          placeholder: 'Seleccionar evento...'
        },
        type:{
          label: 'Tipo de reserva',
          placeholder: 'Seleccionar...'
        },
      }
    },

    routes: {
      titlePlural: 'Rutas',
      titleSingular: 'Ruta',
      form:{},
    },
    routeMap: {
      titlePlural: 'Rutas',
      titleSingular: 'Ruta',
      form:{},
    },
    payments: {
      titlePlural: 'Pagos',
      titleSingular: 'Pago',
      form:{
        user_id: {
          label: 'Usuario',
          placeholder: 'Seleccionar...'
        },
        identifier: {
          label: 'Identificado enviado',
          placeholder: 'Escribir...'
        },
        ci_number: {
          label: 'Carnet de identidad',
          placeholder: 'Escribir...'
        },
        email: {
          label: 'Email',
          placeholder: 'Escribir...'
        },
        cellphone: {
          label: 'Teléfono',
          placeholder: 'Escribir...'
        },
        status: {
          label: 'Estado',
          placeholder: 'Seleccionar...'
        },
        payment_date_from: {
          label: 'Fecha de pago (Desde)',
          placeholder: 'Seleccionar...'
        },
        payment_date_to: {
          label: 'Fecha de pago (Hasta)',
          placeholder: 'Seleccionar...'
        },
        created_at_from: {
          label: 'Fecha de creación (Desde)',
          placeholder: 'Seleccionar...'
        },
        created_at_to: {
          label: 'Fecha de creación (Hasta)',
          placeholder: 'Seleccionar...'
        }
      }
    },
    transactions: {
      titlePlural: 'Transacciones',
      titleSingular: 'Transacción',
      form:{
        payment_method_id: {
          label: 'Método de pago',
          placeholder: 'Seleccionar...'
        },
        user_id: {
          label: 'Usuario',
          placeholder: 'Seleccionar...'
        },
        ci_number: {
          label: 'Carnet de identidad',
          placeholder: 'Escribir...'
        },
        email: {
          label: 'Email',
          placeholder: 'Escribir...'
        },
        cellphone: {
          label: 'Teléfono',
          placeholder: 'Escribir...'
        },

        status: {
          label: 'Estado',
          placeholder: 'Seleccionar...'
        },
        created_at_from: {
          label: 'Fecha de creación (Desde)',
          placeholder: 'Seleccionar...'
        },
        created_at_to: {
          label: 'Fecha de creación (Hasta)',
          placeholder: 'Seleccionar...'
        }
      }
    },
    invoices: {
      titlePlural: 'Facturas',
      titleSingular: 'Factura',
      form:{
        "type": {
          label: 'Tipo de deuda',
          placeholder: 'Seleccionar...'
        },
        ci: {
          label: 'CI',
          placeholder: '...'
        },
        nit_number: {
          label: 'NIT',
          placeholder: '...'
        },
        email: {
          label: 'Email',
          placeholder: '...'
        },
        name: {
          label: 'Nombre',
          placeholder: '...'
        },
        status: {
          label: 'Estado',
          placeholder: 'Seleccionar...'
        },
        payment_date_from: {
          label: 'Fecha de pago (Desde)',
          placeholder: 'Seleccionar...'
        },
        payment_date_to: {
          label: 'Fecha de pago (Hasta)',
          placeholder: 'Seleccionar...'
        },
        created_at_from: {
          label: 'Fecha de creación (Desde)',
          placeholder: 'Seleccionar...'
        },
        created_at_to: {
          label: 'Fecha de creación (Hasta)',
          placeholder: 'Seleccionar...'
        }
      }
    },
    payment_methods: {
      titlePlural: 'Métodos de pago',
      titleSingular: 'Método de pago',
      form:{
        payment_channel_id: {
          label: 'Canal de pago',
          placeholder: 'Seleccionar...'
        },
        active: {
          label: '¿Activo?',
          placeholder: 'Seleccionar...'
        },
        created_at_from: {
          label: 'Fecha de creación (Desde)',
          placeholder: 'Seleccionar...'
        },
        created_at_to: {
          label: 'Fecha de creación (Hasta)',
          placeholder: 'Seleccionar...'
        }
      }
    },
    sendMail: {
      titlePlural: 'Notificaciones',
      titleSingular: 'Notificación',
      form:{},
    },
    salesReport: {
      titlePlural: 'Reportes de ventas',
      titleSingular: 'Reporte de venta',
      form:{},
      form_filter: {
        search: {
          label: 'Buscar código',
          placeholder: 'Escribir código...'
        },
        name:{
          label: 'Nombre',
          placeholder: 'Escribir nombre...'
        },
        lastName:{
          label: 'Apellido',
          placeholder: 'Escribir apellido...'
        },
        email:{
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico...'
        },
        numberCi:{
          label: 'Numero de carnet',
          placeholder: 'Escribir numero de carnet...'
        },
        initial_date:{
          label: 'Fecha inicio',
          placeholder: 'Escribir fecha inicio...'
        },
        end_date:{
          label: 'Fecha fin',
          placeholder: 'Escribir fecha fin...'
        },
        event:{
          label: 'Eventos',
          placeholder: 'Seleccionar evento...'
        },
      }
    },
    agency: {
      titlePlural: 'Agencias',
      titleSingular: 'Agencia',
      form: {
        name: {
          label: 'Nombre de la agencia ',
          placeholder: 'Ingresa tu nombre..'
        },
        address: {
          label: 'Dirección',
          placeholder: 'Ingresa dirección...'
        },
        phone: {
          label: 'Telefono',
          placeholder: 'Ingresa telefono...'
        },
        business: {
          label: 'Empresa',
          placeholder: 'Ingresa nombre de empresa...'
        },
        latitude: {
          label: 'Latitude',
          placeholder: 'Latitude....'
        },
        longitude: {
          label: 'Longitude',
          placeholder: 'Longitude....'
        },
        description: {
          label: 'Descripción',
          placeholder: 'Ingresa descripción....'
        }
      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
      }

    },
    assistance: {
      titlePlural: 'Asistencias',
      titleSingular: 'Asistencia',
      form:{},
    },
    vehicles: {
      titlePlural: 'Aprobar vehiculo',
      titleSingular: 'Aprobar vehiculo',
      form:{},
    },
    seats: {
      titlePlural: 'Reporte de asientos',
      titleSingular: 'Reporte de asiento',
      form:{},
    },
    deliveryTicket: {
      titlePlural: 'Entregas de Tickets',
      titleSingular: 'Entrega de Ticket',
      form:{},
    },
    roles: {
      titlePlural: 'Roles',
      titleSingular: 'Rol',
      form: {
        name: {
          label: 'Nombre del rol',
          placeholder: 'Ingresar nombre...'
        },
        description: {
          label: 'Descripción',
          placeholder: 'Ingresa, descripción y alcance del rol...'
        },
      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        cellphone: {
          label: 'Celular',
          placeholder: 'Ingresa tu número de celular'
        },
        initial_date: {
          label: 'Fecha inicio',
          placeholder: 'Ingresa fecha inicio'
        },
        end_date: {
          label: 'Fecha fin',
          placeholder: 'Ingresa fecha fin'
        },
      }
    },
    permissions: {
      titlePlural: 'Permisos',
      titleSingular: 'Permiso',
      form: {
        name: {
          label: 'Nombre del permisio',
          placeholder: 'Ingresar nombre...'
        },
        description: {
          label: 'Descripción',
          placeholder: 'Ingresa, descripción y alcance del rol...'
        },
      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        cellphone: {
          label: 'Celular',
          placeholder: 'Ingresa tu número de celular'
        },
        initial_date: {
          label: 'Fecha inicio',
          placeholder: 'Ingresa fecha inicio'
        },
        end_date: {
          label: 'Fecha fin',
          placeholder: 'Ingresa fecha fin'
        },
      }
    },
    sendMailCustom: {
      titlePlural: 'Enviar correos',
      titleSingular: 'Enviar correo',
      form:{},
    },
    typePayment: {
      titlePlural: 'Tipos de métodos de pagos',
      titleSingular: 'Tipo de método de pago',
      form:{},
    },
    brands: {
      titlePlural: 'Marca',
      titleSingular: 'Marcas',
      form:{},
    },
    brandsModel: {
      titlePlural: 'Modelos',
      titleSingular: 'Modelo',
      form:{},
    },
    paymentCustom: {
      titlePlural: 'Pagos',
      titleSingular: 'Pago',
      form:{},
    },
    templea: {
      titlePlural: 'Templeas',
      titleSingular: 'Templea',
      form:{},
      form_filter: {}
    },
    debtsLoaded: {
        titlePlural: 'Deudas Cargadas',
        titleSingular: 'Deuda Cargada',
        form:{},
        form_filter: {}
    },
    carryDebts: {
      titlePlural: 'Cargar Deudas',
      titleSingular: 'Carga Deuda',
      form:{},
      form_filter: {}
    },
    question: {
      titlePlural: 'Preguntas',
      titleSingular: 'Pregunta',
      form:{},
      form_filter: {}
    },
    parameters: {
      titlePlural: 'Parametros',
      titleSingular: 'Parametro',
      form:{},
      form_filter: {}
    },
    batches: {
      titlePlural: 'Lotes Notificaciones',
      titleSingular: 'Lote notificación',
      form:{},
      form_filter: {}
    },
  },
  validations: {
    required: "El campo \"{label}\" es requerido.",
    number: "El campo \"{label}\" debe contener solo números.",
    minlength: "El campo \"{label}\" debe tener al menos \"{requiredLength}\" caracteres.",
    maxlength: "El campo \"{label}\" debe tener un máximo de \"{requiredLength}\" caracteres.",
    min: "El campo \"{label}\" debe contener al menos \"{min}\" elementos.",
    max: "El campo \"{label}\" debe tener un máximo de \"{max}\" elementos.",
    email: "El campo \"{label}\" debe ser un email válido.",
    default: "El campo \"{label}\" es inválido.",
  },
  menu: [
    {
      headTitle1: "General",
      permissions:'default',
    },
    {
      id: 1,
      level: 1,
      path: '/account',
      title: "Mi Cuenta",
      icon: "home",
      type: "link",
      permissions:'default',
    },
    {
      id: 1,
      level: 1,
      path: '/event',
      title: "Administrador de Eventos",
      icon: "home",
      type: "link-external-admin",
      permissions:'organization-page-ticket',
    },
    {
      headTitle1: "Usuarios",
      permissions:'organization-title-user',
    },
    {
      id: 2,
      level: 1,
      path: '/users',
      title: "Usuarios del admin",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-users',
    },
    {
      id: 3,
      level: 1,
      path: '/profile',
      title: "Perfiles",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-profiles',
    },
    {
      id: 4,
      level: 1,
      path: '/customer',
      title: "Clientes",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-customers',
    },
    {
      id: 5,
      level: 1,
      path: '/agency',
      title: "Agencia",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-agency',
    },
    {
      headTitle1: "Tickets",
      permissions:'organization-title-tickets',
    },
    {
      id: 5,
      level: 1,
      path: 'history-tickets',
      title: "Reportes de entradas",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-history_tickets',
    },
    {
      id: 5,
      level: 1,
      path: 'assistance',
      title: "Reporte de asistencia",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-assistance',
    },
    {
      id: 5,
      level: 1,
      path: 'report-seats',
      title: "Reporte de Asientos",
      icon: "bookmark",
      type: "link",
      permissions:'defaultt',
    },
    {
      headTitle1: "Notificaciones",
      permissions:'organization-page-send_email',
    },
    {
      id: 5,
      level: 1,
      path: 'send-email',
      title: "Correos enviados",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-send_email',
    },
    {
      headTitle1: "Roles y Premios",
      permissions: 'organization-title-permission',
    },
    {
      id: 10,
      level: 1,
      path: '/roles',
      title: "Roles",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-roles',
    },
    {
      id: 11,
      level: 1,
      path: '/permissions',
      title: "Permisos",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-permission',
    },

  ],
  horizontalMenu: [
    // {
    //     id: 1,
    //     level: 1,
    //     path: '/account',
    //     title: "Mi Cuenta",
    //     icon: "home",
    //     type: "link",
    // },
  ],
};
